import { createFileRoute } from "@tanstack/react-router";
import { buildRouteHead } from "@/lib/seo/routeHead";
import ClinicalOffering from "@/pages/ClinicalOffering";

export const Route = createFileRoute("/zh-cn/services/clinical-solutions/clinical-expert-services")({
  head: () => buildRouteHead("/zh-cn/services/clinical-solutions/clinical-expert-services"),
  component: ClinicalOffering,
});

